import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import '../styles/LegalCompliancePage.css';

const API_URL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5000');

export function LegalCompliancePage() {
  const [legalPolicies, setLegalPolicies] = useState([]);

  const [contactInfo, setContactInfo] = useState({
      public_email: 'contact@fitcoursehub.com'
  });
  const emailLink = `mailto:${contactInfo.public_email}`;

  // Fetch data from file
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('API_URL', API_URL);
        const response = await fetch(`./data/legalCompliance.json`);
        if (response.ok) {
          const data = await response.json();
          setLegalPolicies(data[0]);
          console.log('Legal policies fetched successfully:', legalPolicies);
        }
      } catch (error) {
        console.error('Error fetching legal policies:', error);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="legal-page">
      <HelmetProvider>
        <Helmet>
          <title>
            Legal & Compliance - Get Fit with Daniella
          </title>

          <meta
            name="description"
            content="Review our legal and compliance policies regarding the use of our website and services."
          />

          <link rel="canonical" href="https://getfitwithdaniella.com/legal/" />

          {/* Open Graph */}
          <meta
            property="og:title"
            content="Legal & Compliance - Get Fit with Daniella"
          />

          <meta
            property="og:description"
            content="Review our legal and compliance policies regarding the use of our website and services."
          />

          <meta
            property="og:url"
            content="https://getfitwithdaniella.com/legal/"
          />

          <meta property="og:type" content="website" />

          <meta
            property="og:site_name"
            content="Get Fit with Daniella"
          />

          <meta
            property="og:image"
            content="https://getfitwithdaniella.com/assets/og-image.jpg"
          />

          {/* Twitter / X */}
          <meta
            name="twitter:card"
            content="summary_large_image"
          />

          <meta
            name="twitter:title"
            content="Legal & Compliance - Get Fit with Daniella"
          />

          <meta
            name="twitter:description"
            content="Review our legal and compliance policies regarding the use of our website and services."
          />

          <meta
            name="twitter:image"
            content="https://www.getfitwithdaniella.com/assets/og-image.jpg"
          />
        </Helmet>
      </HelmetProvider>
      <div className="legal-container">
        <div className="legal-header">
          {
            legalPolicies && legalPolicies.info && (
              <div>
                <h1>{legalPolicies.info.header}</h1>
                <p>{legalPolicies.info.content}</p>
                <span className="last-updated">{legalPolicies.info.lastUpdated}</span>
              </div>
            )
          }
          {/* <h1>Legal & Compliance</h1>
          <p>
            Your privacy, safety, and trust are important to us. Please review
            the policies below regarding the use of our website, coaching
            services, and programs.
          </p>

          <span className="last-updated">
            Last Updated: June 2026
          </span> */}
        </div>

        {/* Privacy Policy */}
        {
          legalPolicies && legalPolicies.policies && legalPolicies.policies.map((policy, index) => (
            <section className="legal-section" id={policy.id} key={index}>
              <h2>{policy.title}</h2>
              {policy.content.map((section, idx) => (
                <div key={idx}>
                  <h3>{section.header}</h3>
                  <p>{section.info}</p>
                  {section.list && (
                    <ul>
                      {section.list.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.additionalInfo && (
                    <p>{section.additionalInfo}</p>
                  )}
                </div>
              ))}

              { index === 0 && (<div>
                  <h3>Contact</h3>
                  <div className="contact-box">
                    <p>For privacy-related inquiries, please contact us at:
                    </p>
                    <p><a href={emailLink} className="contact-link"> getfitwithdaniella@gmail.com </a></p>
                  </div>
                </div>)
              }
            </section>
          ))
        }
          {/* <h3>Contact</h3>

          <div className="contact-box">
            <p>For privacy-related inquiries, please contact us at:
            </p>
            <p><a href={emailLink} className="contact-link"> getfitwithdaniella@gmail.com </a></p>
          </div> */}

      </div>
    </div>
  );
}


